module.exports = __webpack_public_path__ + "img/logo1.303064ad.png";